<template>
    <div>
        <banner-list-link :listLayout="listLayout" :bannerData="bannerData"></banner-list-link>
    </div>
</template>

<script>

import alertMixins from "@/mixins/alertMixins";
import bannerUtil from "@/components/banner/bannerUtil";
import DeleteClass from "@/mixins/deleteClass";
import bannerListLink from "@/components/banner/link/BannerListLink";
import util from "@/mixins/util";
import EventBus from "@/utils/event-bus";

export default {
    name: "BannerListComponent",
    mixins: [alertMixins,bannerUtil],
    components: {bannerListLink},
    inject: ['changeLoading'],
    provide() {
        return {
            deleteBanner:this.runDeleteConfirm
        }
    },
    props: {
        bannerType: '',
    },
    data() {
        return {
            listLayout: '',
            listApiParamSet: {},
            getFunc: '',

            deleteFunc: '',
            deleteApiParamsSet: {},
            deleteSuccessType: 1,
            deleteFailTypes: {},
            deleteErrorTypes: [],
            keyName: '',

            DeleteClass: null,
            bannerData:[],
        }
    },
    created() {
        this.initConfig()
        this.newDeleteClass();
    },
    mounted() {
       this.getBanner()
        EventBus.$on('getBannerList',this.getBanner)
    },
    beforeDestroy() {
        EventBus.$off('getBannerList')
    },
    destroyed() {
    },
    computed: {},
    methods: {
        initConfig() {
            let config = this.returnBannerConfig(this.bannerType);
            this.listLayout = config.listLayout;
            this.listApiParamSet = config.listApiParamSet;
            this.getFunc = config.getFunc;

            this.deleteFunc = config.deleteFunc;
            this.deleteApiParamsSet = config.deleteApiParamsSet;
            this.deleteSuccessType = config.deleteSuccessType;
            this.deleteFailTypes = config.deleteFailTypes;
            this.keyName = config.keyName;
        },
        getBanner() {
            let params = JSON.parse(JSON.stringify(this.listApiParamSet));
            this.$api.$banner[this.getFunc](params).then(res => res.Data.Result).then(res => {
                if (res.Info.type != 1) {
                    this.createAlert({
                        title: '',
                        content: '데이터를 불러올 수 없습니다.',
                        btnText: '확인',
                        hide: () => {
                            this.$router.back();
                        }
                    });
                    return;
                }
                this.bannerData = res.List;

            })
        },
        newDeleteClass() {
            let deleteOptions = {
                func: this.$api.$banner[this.deleteFunc],
                apiParamSet: this.deleteApiParamsSet,
                keyName: this.keyName,
                errorTypes: this.deleteErrorTypes,
                successType: this.deleteSuccessType,
                afterFunc: this.deleteAfterFunc,
            }
            this.DeleteClass = new DeleteClass(deleteOptions);
        },
        runDeleteConfirm(key) {
            this.createConfirm({
                content: '정말 삭제하시겠습니까?',
                confirm: () => {
                    this.runDelete(key);
                }
            })
        },
        runDelete(key) {
            this.changeLoading(true);
            this.DeleteClass.runDelete(key);
        },
        deleteAfterFunc(){
            this.changeLoading(false);
            this.createAlert({
                content: '삭제되었습니다.',
                hide: () => {
                    this.getBanner();
                }
            })
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
